const colors = {
  primary900: '#155275',
  primary700: '#2182AA',
  primary: '#33A0C9',
  primary300: '#5FBCD5',
  primary200: '#86CFE0',
  primary100: '#E1F4F7',

  secondary900: '#24323D',
  secondary800: '#354755',
  secondary700: '#7790A3',
  secondary: '#536E81',
  secondary400: '#607d92',
  secondary300: '#8fa4b5',
  secondary100: '#aebecb',

  strong: '#171717',
  normal: 'rgba(23, 23, 23, 0.87)',
  assisitive: 'rgba(23, 23, 23, 0.7)',
  supportive: 'rgba(23, 23, 23, 0.4)',
  disabled: 'rgba(23, 23, 23, 0.15)',

  fill12: 'rgba(23, 23, 23, 0.012)',
  fill05: 'rgba(23, 23, 23, 0.005)',
  fill03: 'rgba(23, 23, 23, 0.03)',
  fill02: 'rgba(23, 23, 23, 0.02)',

  darkest: '#444749',
  darker: '#676969',
  dark: '#9E9FA0',
  light: '#BEBFC0',
  lighter: '#E1E2E4',
  lightest: '#F3F4F6',
  backgroundGray: 'rgba(190, 191, 192, 0.12)',

  white: '#FFFFFF',
  alert: '#F14841',
  warning: '#FBB54A',
  success: '#3CCB39',

  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.15)',
};

const deviceSize = {
  desktop: '1600px',
  tablet: '1023px',
  mobile: '767px',
};

const device = {
  desktop: `only screen and (max-width: ${deviceSize.desktop})`,
  tablet: `only screen and (max-width: ${deviceSize.tablet})`,
  mobile: `only screen and (max-width: ${deviceSize.mobile})`,
};

export const theme = {
  colors,
  device,
  deviceSize,
};
